"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlideoutFields = void 0;
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const SlideoutFields = (props) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, props.fields.map((field) => (react_1.default.createElement(SlideoutField, Object.assign({ key: field.label }, field))))));
};
exports.SlideoutFields = SlideoutFields;
const SlideoutField = (props) => {
    if (props.value != null) {
        return (react_1.default.createElement(material_1.Box, { pt: 1, sx: {
                '&:first-of-type': {
                    paddingTop: 0,
                },
            } },
            react_1.default.createElement(material_1.Typography, { variant: 'body1', fontWeight: 500 },
                props.label,
                ":",
                react_1.default.createElement(material_1.Typography, { component: 'span', variant: 'body1', sx: { display: 'inline', pl: 1 } }, props.value))));
    }
    else {
        return null;
    }
};
